import { computed } from 'vue'

import type { ButtonSize } from '../types'

export function useLabelBindings(size: ButtonSize) {
    const labelBindings = computed(() => {
        const labelSizesMap = {
            xs: { size: 'xs', accent: true },
            s: { size: 's', accent: true },
            m: { size: 'm', accent: true },
            l: { size: 'm', accent: true },
            xl: { size: 'l', semibold: true },
        } as const

        return labelSizesMap[size]
    })

    return {
        labelBindings,
    }
}
